// extracted by mini-css-extract-plugin
export var li = "_ty-2";
export var ol = "_ty-1";
export var ul = "_ty-0";